import { TextM } from 'components/Text';
import { ConfirmationToken } from 'components/ConfirmationToken';

interface IPostingRejectConfirmationProps {
	isLoading: boolean;
	onClose: () => void;
	onConfirm: (mfaToken: string) => void;
}
const PostingRejectConfirmation = ({
	isLoading,
	onClose,
	onConfirm,
}: IPostingRejectConfirmationProps) => {
	return (
		<ConfirmationToken
			isLoading={isLoading}
			onClose={onClose}
			onConfirm={onConfirm}
		>
			<TextM>
				Para sua segurança, realize a autenticação do seu dispositivo
				para aprovar essa transferência.
			</TextM>
		</ConfirmationToken>
	);
};

export default PostingRejectConfirmation;
